import {IDS} from '../audit-action-id.constants';
import {TYPES} from '../audit-action-type.constants';
import {TYPES as ACC_TYPES} from '../../accreditation-action-type.constants'
import {TAB_SHOW} from '../../../../common/tabs/tabs.constants';
import * as AuditActions from '../audit.actions'
import * as AccActions from '../../accreditation.actions'
import * as RequirementsActions from '../../requirements-assessment/requirements-assessment.actions';
import moment from 'moment';
import isFunction from "lodash/isFunction";
import get from "lodash/get";
import isUndefined from "lodash/isUndefined";
import {IDS as SECTION_IDS} from "../../requirements-assessment/requirements-assessment-action-id.constants";
import {GRID_FILTER} from "../../../../common/grid/grid.constants";

class AuditScheduleController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $uiRouterGlobals,
                $scope,
                $rootScope,
                $filter,
                $mdDialog,
                Notifier,
                DocumentManager,
                AuthService,
                AccountService,
                EmployeeService,
                $timeout) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$mdDialog = $mdDialog;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.user = AuthService.getUser();
        this.AccountService = AccountService;
        this.EmployeeService = EmployeeService;
        this.$timeout = $timeout;
        this.identifier = IDS.accAudit;
        this.selectedFormat = null;

        this.exportFormat = [
            {format: 'pdf',     name: 'PDF'},
            {format: 'csv',     name: 'CSV'},
            {format: 'xls',     name: 'Excel 5'},
            {format: 'xlsx',    name: 'Excel 2007'}
        ]
    }

    $onInit() {
        this.unsubscribe = this.$ngRedux.connect(state => {
            const {monthColumns, sectionRows} = state.accreditation.accAudit.schedule;
            const {fiscalYearStart} = state.accreditation.accAudit.siteLocation;
            const headOfficeFiscalYearStart = state.accreditation.accAudit.headOfficeFiscalYearStart;
            const {siteLocation, headOffice, year} = state.accreditation.accDashboardLocationYear;
            const sectionsTree = state.accreditation.sectionsTree;
            const selectedRequirement = state.accreditation.selectedRequirement;
                return {
                    fiscalYear: year,
                    fiscalYearRange: `${year} - ${parseInt(year) + 1}`,
                    fiscalYearStart: !isUndefined(fiscalYearStart) ? fiscalYearStart : headOfficeFiscalYearStart,

                    headOffice,     // uuid
                    siteLocation,   // uuid

                    monthColumns,
                    sectionRows,

                    sectionsTree,
                    sectionLevel:               selectedRequirement?.level,

                    showExportPanel:            Boolean(get(sectionRows, 'length')),
                }
            }, {
            ...RequirementsActions, 
            ...AccActions, 
            ...AuditActions
        })(this);
        const {itemCode, requirement, hof, slo, year} = this.$stateParams;
        this.schemeCode = itemCode;
        this.paramsRequirement = requirement;
        this.paramsHof = hof;
        this.paramsSlo = slo;
        this.selectCascadeBehaviour = this.paramsSlo ? '' : 'selectDefault'; // if site location is not set, select first head office and site location
        this.paramsYear = year;
        this.$stateParams = null;

        this.getRegulatoryFrameworkDetails(this.schemeCode).then(({name, id}) => {
            this.title = name;
            // this.schemeId = id;
        });

        this.$scope.$on('LOCATION_SUBJECT_SELECTED', this.onLocationChange.bind(this));
        this.$scope.$on('LOCATION_SUBJECT_NOT_FOUND', this.onLocationNotFound.bind(this));
        this.$scope.$on('SELECT_CASCADE_SUBJECTS_LOADED', this.onSelectCascadeLoaded.bind(this));
    }

    async onSelectCascadeLoaded() {
        if(this.paramsSlo && this.paramsYear) {
            if(!this.paramsHof) {
                const result = await this.EmployeeService.getEmploymentLocations(this.paramsSlo);
                this.paramsHof = result[0].uuid;
            }
            this.$ngRedux.dispatch({
                type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                accDashboardLocationYear: {
                    headOffice: this.paramsHof,
                    siteLocation: this.paramsSlo,
                    year: this.paramsYear,
                }
            });
            this.initSelectCascade(this.paramsHof, this.paramsSlo);
        }
        else if(this.headOffice && this.siteLocation) {
            this.initSelectCascade(this.headOffice, this.siteLocation);
        }
    }

    initSelectCascade(headOffice, siteLocation) {
        const isSingleSiteUser = this.user.parentCount === 1 && this.user.parents[0].basicType === 'slo';
        if (isSingleSiteUser) {
            this.$rootScope.$broadcast('FORCE_SELECT_PARENT', 0, siteLocation, null);
        } else {
            this.$rootScope.$broadcast('FORCE_SELECT_PARENT', 0, headOffice, siteLocation);
        }
    }

    async onLocationChange (evt, loc) {
        const subjectType = get(loc,'in_subject_basic_type_code');
        if(subjectType === 'hof') {
            const headOffice = get(loc, 'in_subject_uuid');

            // if site in url params wait for onSelectCascadeLoaded() to set the site
            if(this.paramsHof && this.paramsHof !== headOffice) {
                return;
            }
            const data = await this.AccountService.fetchHeadOffice(headOffice)
            this.$ngRedux.dispatch({
                type: TYPES.FETCH_HEAD_OFFICE_DETAILS,
                id: IDS.addAudit,
                data,
            });
            this.$ngRedux.dispatch({
                type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                accDashboardLocationYear: {
                    headOffice,
                    // siteLocation: null,
                    // year: this.fiscalYear,
                }
            });
        }
        else if(subjectType === 'slo') {
            const siteLocation = get(loc, 'in_subject_uuid');

            // if site in url params wait for onSelectCascadeLoaded() to set the site
            if(this.paramsSlo && this.paramsSlo !== siteLocation) {
                return;
            }
            this.$ngRedux.dispatch({
                type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                accDashboardLocationYear: {
                    siteLocation,
                    year: this.fiscalYear,
                }
            });
            const ctrl = this;
            this.fetchSiteLocationDetails( this.siteLocation ).then( () => {
                ctrl.fetchAudits(
                    ctrl.schemeCode,
                    ctrl.siteLocation,
                    ctrl.fiscalYear,
                    ctrl.fiscalYearStart).then(() => {
                }).then(()=>{
                    if(ctrl.paramsSlo && ctrl.paramsYear && ctrl.paramsRequirement) {
                        if(ctrl.sectionsTree.length){
                            ctrl.switchToAuditDetailsTab(ctrl, parseInt(ctrl.paramsRequirement), ctrl.paramsSlo, ctrl.paramsYear);
                        }
                        else {
                            ctrl.fetchAssessmentRequirementsTreeProgress(ctrl.schemeCode, ctrl.paramsSlo, ctrl.paramsYear).then((data) => {
                                ctrl.switchToAuditDetailsTab(ctrl, parseInt(ctrl.paramsRequirement), ctrl.paramsSlo, ctrl.paramsYear);
                            });
                        }
                    }
                });
            });
            ctrl.fetchSiteLocationContacts( loc.in_subject_uuid );
        }
    };

    async switchToAuditDetailsTab(ctrl, section, siteLocation, year) {
        ctrl.selectRequirementById(section);

        let rowIndex = ctrl.sectionRows.findIndex(item =>
            item.id === section
        );
        if(rowIndex) {
            let row;
            for (rowIndex; rowIndex >= 0; rowIndex--) {
                row = ctrl.sectionRows[rowIndex];
                if (row?.cells.find(item => item?.sectionId))
                    break;
            }
            if(!row)
                return;
            const cellIndex = row.cells.findIndex(item => item);
            ctrl.onSelectScheduleCell(row, cellIndex);
        }
        ctrl.clearParams(ctrl);
    }

    clearParams(ctrl) {
        ctrl.paramsRequirement = null;
        ctrl.paramsHof = null;
        ctrl.paramsSlo = null;
        ctrl.paramsYear = null;
    }

    onLocationNotFound(event, location) {
        this.hideSelectSiteLocation = true;
        if(this.selectedLocationUuid || this.user.parentCount !== 1)
            return

        const ctrl = this;
        this.EmployeeService.getEmploymentLocations(this.user.uuid).then(siteLocations => {
            const selectedLocationUuid = get(siteLocations,'[0].uuid');
            if(selectedLocationUuid) {
                ctrl.selectedLocationUuid = selectedLocationUuid;
                this.fetchSiteLocationContacts( ctrl.selectedLocationUuid );
                this.fetchSiteLocationDetails( ctrl.selectedLocationUuid ).then( () => {
                    this.fetchAudits(this.schemeCode, ctrl.selectedLocationUuid, this.fiscalYear, this.fiscalYearStart)
                });
            }
        });
    }

    onYearChange({item}) {
        this.$stateParams.year = item.value;
        this.fetchSiteLocationDetails( this.siteLocation ).then( () => {
            this.fetchAudits(this.schemeCode, this.siteLocation, this.fiscalYear, this.fiscalYearStart);
        });
    }

    getCellStyle(auditItem, index) {
        if(auditItem.disabled)
            return 'table-info';
        else if(auditItem.cells[index]) {
            switch(auditItem.cells[index].status) {
                case 'don': return 'table-success';
                case 'sch': return 'table-warning';
                case 'ove': return 'table-danger';
            }
        }
        if(this.monthColumns[index]) {
            const [monthName, year] = this.monthColumns[index].split(' ');
            if (moment().year(year).month(monthName).isBefore(moment()))
                return "background-light-gray"
        }
    };

    onSelectScheduleCell(requirementRow, index) {
        if(requirementRow.disabled) {
            return;
        }
        const cell = requirementRow.cells[index];
        // if audit scheduled go to audit details
        if(cell){
            this.$ngRedux.dispatch({
                type: TYPES.REFRESH_AUDIT_DETAILS,
                id: IDS.accAudit,
                data: {
                    ...cell,
                    auditors: [...cell.auditors],
                    sourceTab: IDS.app_accreditation_scheme_audit_schedule_table,
                }
            });

            this.$ngRedux.dispatch({
                type: TAB_SHOW,
                id: IDS.app_accreditation_scheme_audit_schedule,
                state: [IDS.app_accreditation_scheme_audit_schedule_details],
                // stateParams: {
                //     hof: this.headOffice,
                //     slo: this.siteLocation,
                //     year: this.fiscalYear,
                //     section: requirementRow.id,
                // },
            });
        }
        // if no audit scheduled go to add audit page
        else if(!requirementRow.cells.some(() => true)){
            const monthYear = moment(this.monthColumns[index]);
            const lastDayOfSelectedMonth = moment(monthYear).add(1,'months').subtract(1, 'days').format('YYYY-MM-DD');

            this.$ngRedux.dispatch({
                type: TYPES.PRESELECT_REQUIREMENT_FOR_NEW_AUDIT,
                requirementId: requirementRow.id
            });

            this.$state.go(IDS.app_accreditation_scheme_audit_add, {
                itemCode:   this.schemeCode,
                year:       this.fiscalYear,
                slo:        this.siteLocation,
                hof:        this.headOffice,
                due_date:   lastDayOfSelectedMonth,
            });
        }
    }

    onSelectRequirementCell(requirementRow) {
        if(requirementRow.disabled) {
            return;
        }
        const ctrl = this;
        this.fetchFrameworkRequirementsTreeProgress(this.schemeCode, this.siteLocation, this.fiscalYear).then(() => {
            ctrl.selectRequirementById(requirementRow.id);
            let newState;
            switch(ctrl.sectionLevel) {
                case 2: newState = SECTION_IDS.app_accreditation_scheme_requirements_assessment_dashboard; break;
                case 3: newState = SECTION_IDS.app_accreditation_scheme_requirements_assessment_evidence_groups; break;
            }
            if(newState) {
                ctrl.$state.go(newState, {
                    itemCode:   ctrl.schemeCode,
                    requirement:requirementRow.id,
                    year:       ctrl.fiscalYear,
                    slo:        ctrl.siteLocation,
                });
            }
            // ctrl.unselectAllTreeNodes();
        });
    }

    onNotApplicableCheckboxChange(notApplicable, requirementRow) {
        this.setRequirementApplicability(requirementRow.id, this.schemeCode, this.siteLocation, this.fiscalYear, notApplicable);
    }

    findExistingReviewInSameFiscalYear(auditItem, selectedIndex) {
        let [selectedMonthName, selectedYear] = this.monthColumns[selectedIndex].split(' ');
        const selectedMonth = moment().month(selectedMonthName).month();
        if(selectedMonth < this.fiscalYearStart)
            selectedYear -= 1;
        const firstMonthOfFiscalYearLabel = this.monthColumns.find(item => {
            let [monthName, year] = item.split(' ');
            const month = moment().month(monthName).month();
            return (parseInt(year) === parseInt(selectedYear) && month === this.fiscalYearStart);
        });
        const firstMonthOfFiscalYearIndex = this.monthColumns.indexOf(firstMonthOfFiscalYearLabel);
        const fiscalYearCells = auditItem.cells.slice(firstMonthOfFiscalYearIndex, firstMonthOfFiscalYearIndex + 12);
        return fiscalYearCells.find(item => item);
    }

    onAuditItemCheckboxChange(auditItem) {
        const statusCode = auditItem.disabled ? 'inv' : 'act';
        this.submitReviewSchedule(auditItem.id, null, this.siteLocation, 0, 0, statusCode);
    }

    exportSchedule() {
        if (isFunction(this.fetchAudits)) {
            this.fetchAudits(
                this.schemeCode,
                this.siteLocation,
                this.fiscalYear,
                this.fiscalYearStart,
                'utrcau',
                this.selectedFormat
            ).then(response => {
                    this.selectedFormat = null;
                    this.DocumentManager.downloadFile('/' + response.data.path);
                    this.$mdDialog.hide();
                    this.Notifier.success('Export Complete!');
                });
        }
        else {
            throw new Error('Missing export action definition');
        }
    }

    $onDestroy() {
        this.$ngRedux.dispatch({
            type: TYPES.RESET_SCHEDULE,
            id: this.identifier
        });
        this.unsubscribe();
        if (this.dialog)
            this.$mdDialog.hide(this.dialog);
    }
}

AuditScheduleController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$uiRouterGlobals',
    '$scope',
    '$rootScope',
    '$filter',
    '$mdDialog',
    'Notifier',
    'DocumentManager',
    'AuthService',
    'AccountService',
    'EmployeeService',
    '$timeout']

export const accAuditSchedule = {
    controller: AuditScheduleController,
    template: require('./schedule.html')
}
